export default {"src":"/_next/static/media/schaatsen.83421f77.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};